import { store } from "../store/store";
import axios from "axios";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import moment from "moment";
import { isWorkingShift } from "../utils/helpers";
import { Localize } from "../lang/langs";

export default class ExcelManager {

    static getInstance() {
        if (!this.instance) {
            this.instance = new ExcelManager()
        }
        return this.instance;
    }

    /**
     * Function to generate and download report
     */
    async generateAndDownloadComptaReport() {
        const workbook = new ExcelJS.Workbook()
        workbook.creator = 'Groupe Vital Dev'
        workbook.created = new Date()

        let rowHeaderProps = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'cccccc' }
        }

        let borderStyle = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
        let planningSheet = workbook.addWorksheet('Planning')
        let row = planningSheet.addRow([
            "Nom société",
            "Matricule",
            "Salariés",
            "H100",
            "H125",
            "H200",
            "Majoration Heures Nuit 50",
            "Total (Heures)",
            "Rapport (%)",
            "Astreint (Jours)"
        ])
        row.eachCell(cell => {
            cell.border = borderStyle
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            cell.fill = rowHeaderProps;
        })

        const state = store.getState()
        state.collabs.list.map(collab => {
            let collabHours = this.getCollabHours(collab.id)
            let overall = this.calculateTotalHoursForCollab(collabHours)
            let astreint = this.getTotalAstreintForCollab(collab.id)
            row = planningSheet.addRow([
                collab.company || "",
                collab.matricule || "",
                `${collab.prenom} ${collab.nom}`,
                collabHours.h100.toFixed(2),
                collabHours.h125.toFixed(2),
                collabHours.h200.toFixed(2),
                collabHours.hmn.toFixed(2),
                overall.total.toFixed(2),
                overall.ratio.toFixed(2),
                astreint.toFixed(2)
            ])
            row.eachCell(cell => {
                cell.border = borderStyle
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            })
        })

        planningSheet = this.autoWidth(planningSheet)

        const buffer = await workbook.xlsx.writeBuffer()
        var blob = new Blob([buffer])
        let date = new moment(state.planning.selectedDate, "x")
        saveAs(blob, `Export_${date.format("MMMM_YYYY")}.xlsx`)
    }

    /**
     * Get collab planning hours
     * @param {*} collabId 
     * @returns 
     */
    getCollabHours(collabId) {
        const state = store.getState()
        let heureDebutNuit = 21, heureFinNuit = 7
        Object.values(state.settings.settingsList).map(item => {
            if (item.label === "Heure début nuit") heureDebutNuit = item.settingValue
            if (item.label === "Heure fin nuit") heureFinNuit = item.settingValue
        })

        let hoursObj = {
            h100: 0,
            h125: 0,
            h200: 0,
            hmn: 0
        }

        state.planning.planningList
            .filter(s => (s.id_collab == collabId && isWorkingShift(s)))
            .map(shift => {
                let startDate = new Date(shift.from)
                let endDate = new Date(shift.to)
                let nightStart = new Date(startDate.getTime())
                nightStart.setHours(heureDebutNuit)
                nightStart.setMinutes(0)
                let nightEnd = new Date(startDate.getTime())
                nightEnd.setDate(nightEnd.getDate() + 1)
                nightEnd.setHours(heureFinNuit)
                nightEnd.setMinutes(0)
                let shiftDuration = ((shift.to - shift.from) / (60 * 60 * 1000))

                // Calculate extra & night hours
                let heuresNuit = 0, heuresSupp = 0, heuresNormal = 0
                if (endDate.getTime() > nightStart.getTime()) {
                    heuresNuit += ((endDate.getTime() - nightStart.getTime()) / (60 * 60 * 1000))
                    if (endDate.getTime() > nightEnd.getTime()) {
                        heuresNuit -= ((endDate.getTime() - nightEnd.getTime()) / (60 * 60 * 1000))
                    }
                }
                if (shiftDuration > 8) {
                    heuresNormal += 8
                    heuresSupp += shiftDuration - 8
                } else {
                    heuresNormal += shiftDuration
                }
                hoursObj.hmn += heuresNuit

                // Attribute normal hours to day of the week
                if (startDate.getDay() == 0) {
                    hoursObj.h200 += heuresNormal + heuresSupp
                } else if (startDate.getDay() == 6) {
                    hoursObj.h125 += heuresNormal + heuresSupp
                } else {
                    hoursObj.h100 += heuresNormal
                    hoursObj.h125 += heuresSupp
                }
            })
        return hoursObj
    }

    /**
     * Get collab planning hours
     * @param {*} collabId 
     * @returns 
     */
    getTotalAstreintForCollab(collabId) {
        const state = store.getState()
        let total = 0
        state.planning.planningList
            .filter(s => (s.id_collab == collabId && !s.absent && ['AST'].includes(s.type)))
            .map(shift => {
                let shiftDuration = ((shift.to - shift.from) / (60 * 60 * 1000))
                total += shiftDuration
            })
        console.log(total)
        return total / 24
    }

    /**
     * 
     * @param {*} hoursObj 
     * @returns 
     */
    calculateTotalHoursForCollab(hoursObj) {
        const state = store.getState()
        let monthHours = 151.67
        Object.values(state.settings.settingsList).map(item => {
            if (item.label === "Base horaire mensuelle") monthHours = item.settingValue
        })
        let h100 = hoursObj.h100,
            h125 = hoursObj.h125,
            h200 = hoursObj.h200,
            hmn = hoursObj.hmn
        let total = h100, ratio = 0
        // Adjust the normal hours from extra hours
        while (total < monthHours && (h125 > 0 || h200 > 0 || hmn > 0)) {
            let missingNormalHours = monthHours - total
            if (hmn > 0) {
                let remainingRealHours = this.getRemainingRealHours(hmn / 2, missingNormalHours)
                total += (hmn / 2) - remainingRealHours
                hmn = remainingRealHours * 2
            } else if (h125 > 0) {
                let remainingRealHours = this.getRemainingRealHours(h125, missingNormalHours)
                total += h125 - remainingRealHours
                h125 = remainingRealHours
            } else if (h200 > 0) {
                let remainingRealHours = this.getRemainingRealHours(h200, missingNormalHours)
                total += h200 - remainingRealHours
                h200 = remainingRealHours
            }
        }
        //Now add the remaining extra hours
        if (hmn > 0) {
            total += hmn / 2
        }
        if (h125 > 0) {
            total += h125 * 1.25
        }
        if (h200 > 0) {
            total += h200 * 2
        }
        ratio = (total / monthHours) * 100
        return { total, ratio }
    }

    /**
     * 
     * @param {*} realHours 
     * @param {*} missingNormalHours 
     * @returns 
     */
    getRemainingRealHours(realHours, missingNormalHours) {
        if (realHours <= missingNormalHours) {
            return 0
        } else {
            return realHours - missingNormalHours
        }
    }

    /**
     * Function to generate and download data in excel format
     * @param {Array} data 
     * @param {String} name 
     */
    async generateAndDownloadExcelFromData(data, name) {
        const workbook = new ExcelJS.Workbook()
        workbook.creator = 'Groupe Vital Dev'
        workbook.created = new Date()

        let rowHeaderProps = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'cccccc' }
        }

        let borderStyle = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
        let sheet = workbook.addWorksheet('Export')
        if (data.length) {
            let row = sheet.addRow(Object.keys(data[0]))
            row.eachCell(cell => {
                cell.border = borderStyle
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
                cell.fill = rowHeaderProps;
            })

            data.map(item => {
                row = sheet.addRow(Object.values(item))
                row.eachCell(cell => {
                    cell.border = borderStyle
                    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
                })
            })

            sheet = this.autoWidth(sheet)
        }

        const buffer = await workbook.xlsx.writeBuffer()
        var blob = new Blob([buffer])
        saveAs(blob, `Export_${name}.xlsx`)
    }

    /**
     * Autofit columns by width
     * @param {*} worksheet 
     * @param {*} minimalWidth 
     * @returns 
     */
    autoWidth(worksheet, minimalWidth = 10) {
        worksheet.columns.forEach((column) => {
            let maxColumnLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
                maxColumnLength = Math.max(
                    maxColumnLength,
                    minimalWidth,
                    cell.value ? this.getMaxLineWidth(cell.value) : 0
                )
            })
            column.width = maxColumnLength + 2
        })
        return worksheet
    }

    getMaxLineWidth(text) {
        if (!text) return 0

        // Split text by line breaks
        const lines = text.toString().split(/\r?\n/)

        // Find the length of the longest line
        const maxLength = lines.reduce((max, line) => {
            return Math.max(max, line.length)
        }, 0)

        return maxLength <= 100 ? maxLength : 100
    }


    /**
     * Annual prime report for ANY evaluation type.
     *
     * Replaces GenerateAndDownloadAnnualPrimeReport (Collab) and
     * ...ReportDM, which were near-identical apart from two columns. Driven by the
     * response of generateAnnualPrimeReportByType, so a type created in Settings exports
     * without a new method here.
     *
     * Three defects from the methods above are fixed rather than carried over:
     *   1. The date columns were read from `collab.start_date`, which the API never
     *      returns at the top level — they were always blank. Derived from `intervals`.
     *   2. The Collab border ranges (3-5 / 6-8 / 9-11 / 10-14) did not line up with the
     *      quarter groups they were meant to outline (3-6 / 7-10 / 11-14).
     *   3. Team names were not shown at all, so a collab who moved teams mid-year was
     *      indistinguishable from one who did not.
     *
     * @param {Array}  jsonData  `annual_report` from the API
     * @param {object} options
     * @param {string} [options.typeTitle]  evaluation type name, used in the sheet name
     * @param {string} [options.fileName]
     */
    async GenerateAndDownloadAnnualPrimeReportByType(jsonData, options = {}) {
        const { typeTitle = 'Evaluations', fileName } = options

        const workbook = new ExcelJS.Workbook()
        workbook.creator = 'Groupe Vital Dev'
        workbook.created = new Date()

        // Excel caps sheet names at 31 chars and rejects []:*?/\
        const sheetName = String(typeTitle).replace(/[\[\]:*?/\\]/g, '').slice(0, 31) || 'Evaluations'
        const worksheet = workbook.addWorksheet(sheetName)

        const MONTH_KEYS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
        const MONTH_LABELS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aoû', 'Sep', 'Oct', 'Nov', 'Dec']

        // Column layout. Months occupy C..N (3..14); the three quarter groups are
        // C:F, G:J, K:N — every merge and border below derives from these.
        const FIRST_MONTH_COL = 3
        const QUARTER_GROUPS = [
            { label: 'Q1', firstCol: 3, lastCol: 6, key: 'Q1' },
            { label: 'Q2', firstCol: 7, lastCol: 10, key: 'Q2' },
            { label: 'Q3', firstCol: 11, lastCol: 14, key: 'Q3' },
        ]
        const colLetter = (col) => worksheet.getColumn(col).letter

        worksheet.columns = [
            { header: 'Nom - Prenom', key: 'name', width: 40 },
            { header: 'Matricule', key: 'matricule', width: 20 },
            ...MONTH_KEYS.map(key => ({ header: '', key, width: 10 })),
            { header: 'Équipe(s)', key: 'teams', width: 30 },
            { header: 'Date début', key: 'start_date', width: 16 },
            { header: 'Date fin', key: 'end_date', width: 16 },
        ]

        const centre = { horizontal: 'center' }

        const mergeQuarters = (rowNumber, valuesByKey) => {
            for (const group of QUARTER_GROUPS) {
                const first = `${colLetter(group.firstCol)}${rowNumber}`
                worksheet.mergeCells(`${first}:${colLetter(group.lastCol)}${rowNumber}`)
                if (valuesByKey) worksheet.getCell(first).value = valuesByKey[group.key]
                worksheet.getCell(first).alignment = centre
            }
        }

        jsonData.forEach(collab => {
            // Quarter banner
            const bannerRow = worksheet.addRow({})
            mergeQuarters(bannerRow.number, { Q1: 'Q1', Q2: 'Q2', Q3: 'Q3' })

            // The API returns per-team intervals, not a single span. Take the outer
            // bounds so the columns say something true for people who changed teams.
            const intervals = collab.intervals || []
            const starts = intervals.map(i => i.start_date).filter(Boolean).sort()
            const ends = intervals.map(i => i.end_date).filter(Boolean).sort()
            const teamNames = [...new Set(intervals.map(i => i.team_name).filter(Boolean))].join(', ')

            const headerRow = worksheet.addRow({
                name: `${collab.prenom} ${collab.nom}`,
                matricule: collab.matricule,
                ...MONTH_KEYS.reduce((acc, key, i) => ({ ...acc, [key]: MONTH_LABELS[i] }), {}),
                teams: teamNames,
                start_date: starts.length ? moment(starts[0]).format('DD-MM-YYYY') : '',
                end_date: ends.length ? moment(ends[ends.length - 1]).format('DD-MM-YYYY') : '',
            })
            worksheet.getCell(`A${headerRow.number}`).alignment = centre
            for (let col = FIRST_MONTH_COL; col < FIRST_MONTH_COL + 12; col++) {
                worksheet.getCell(headerRow.number, col).alignment = centre
            }
            headerRow.font = { bold: true }

            // One value row + one comment row per evaluated criterion, in the order the
            // API returned them (which is field rank).
            const fieldTitles = []
            for (const monthData of collab.evaluationData || []) {
                for (const evaluation of monthData.evaluations || []) {
                    if (!fieldTitles.includes(evaluation.title)) fieldTitles.push(evaluation.title)
                }
            }

            fieldTitles.forEach(field => {
                const valuesRow = worksheet.addRow({ name: field, matricule: 'Valeur' })
                const commentsRow = worksheet.addRow({ matricule: 'Commentaire' })

                for (const monthData of collab.evaluationData || []) {
                    const monthIndex = MONTH_KEYS.indexOf(monthData.month)
                    if (monthIndex === -1) continue

                    for (const evaluation of monthData.evaluations || []) {
                        if (evaluation.title !== field) continue

                        const col = FIRST_MONTH_COL + monthIndex
                        valuesRow.getCell(col).value = evaluation.value === 'yes' ? 'Oui' : 'Non'
                        commentsRow.getCell(col).value = evaluation.comments || ''
                        valuesRow.getCell(col).alignment = centre
                        commentsRow.getCell(col).alignment = centre
                    }
                }

                worksheet.mergeCells(`A${valuesRow.number}:A${commentsRow.number}`)
                worksheet.getCell(`A${valuesRow.number}`).alignment = {
                    horizontal: 'center', vertical: 'middle', wrapText: true
                }
            })

            // Per-quarter summary rows
            const summaryRows = [
                { label: 'Absence justifiée', source: collab.leaves },
                { label: 'Absence injustifiée', source: collab.absences },
                { label: 'Prime', source: collab.prime },
            ]

            for (const { label, source } of summaryRows) {
                const row = worksheet.addRow({ name: label })
                worksheet.mergeCells(`A${row.number}:B${row.number}`)
                worksheet.getCell(`A${row.number}`).alignment = centre
                mergeQuarters(row.number, source || {})
            }

            worksheet.addRow()
        })

        const thinBorder = {
            top: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
        }

        // Outline each quarter group, on every row below the header.
        worksheet.eachRow((row, rowIndex) => {
            if (rowIndex < 2) return
            for (const group of QUARTER_GROUPS) {
                for (let col = group.firstCol; col <= group.lastCol; col++) {
                    worksheet.getCell(rowIndex, col).border = thinBorder
                }
            }
        })

        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        })

        saveAs(blob, fileName || `Evaluations_${sheetName.replace(/\s+/g, '_')}.xlsx`)
    }

    /**
     * Builds and downloads a multi-sheet workbook for the V-Sécurité dashboard.
     *
     *   Sheet 1 — Tableau de bord:   KPI summary cards
     *   Sheet 2 — Sensibilisation:   per-team awareness breakdown
     *   Sheet 3 — Quiz:              per-team quiz breakdown
     *   Sheet 4 — Détail Sensib.:    per-collab × campaign rows
     *   Sheet 5 — Détail Quiz:       per-collab × quiz rows
     *
     * @param {object} summary           - Dashboard summary from Redux state.
     * @param {Array}  byTeam            - Per-team rows from Redux state.
     * @param {Array}  awarenessDetails  - Per-collab × campaign rows from API.
     * @param {Array}  quizDetails       - Per-collab × quiz rows from API.
     * @param {string} lang              - Active language code.
     */
    async generateAndDownloadVSecuriteDashboardReport(summary, byTeam, awarenessDetails, quizDetails, lang) {
        const workbook = new ExcelJS.Workbook()
        workbook.creator = 'Groupe Vital Dev'
        workbook.created = new Date()

        const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF9015' } }
        const headerFont = { bold: true, color: { argb: 'FFFFFF' } }
        const borderStyle = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }

        const styleHeaderRow = (row) => {
            row.eachCell((cell) => {
                cell.border = borderStyle
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
                cell.fill = headerFill
                cell.font = headerFont
            })
        }

        const styleBodyRow = (row) => {
            row.eachCell((cell) => {
                cell.border = borderStyle
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            })
        }

        const toNum = (val) => {
            const n = Number(val)
            return isNaN(n) ? 0 : n
        }

        // ── Sheet 1: Summary ──────────────────────────────────────────────────
        let summarySheet = workbook.addWorksheet(Localize('VSEC_TAB_DASHBOARD', lang))
        let summaryHeader = summarySheet.addRow([
            Localize('VSEC_COL_TITLE', lang),
            Localize('VSEC_COL_COMPLETED', lang)
        ])
        styleHeaderRow(summaryHeader)

        const summaryRows = [
            [Localize('VSEC_CARD_CAMPAIGNS_PUBLISHED', lang), toNum(summary?.total_campaigns_published)],
            [Localize('VSEC_CARD_RATE_COMPLETION', lang),     `${toNum(summary?.total_campaigns_completed_rate)}%`],
            [Localize('VSEC_CARD_QUIZZES_PUBLISHED', lang),   toNum(summary?.total_quizzes_published)],
            [Localize('VSEC_CARD_RATE_SUCCESS', lang),        `${toNum(summary?.total_quizzes_passed_rate)}%`],
            [Localize('VSEC_CARD_PENDING_AWARENESS', lang),   toNum(summary?.employees_with_pending_awareness)],
            [Localize('VSEC_CARD_PENDING_QUIZZES', lang),     toNum(summary?.employees_with_pending_quizzes)]
        ]
        summaryRows.forEach((cells) => styleBodyRow(summarySheet.addRow(cells)))
        summarySheet = this.autoWidth(summarySheet)

        const teamRows = Array.isArray(byTeam) ? byTeam : []

        // ── Sheet 2: Sensibilisation par équipe ──────────────────────────────
        let awarenessSheet = workbook.addWorksheet(Localize('VSEC_TAB_AWARENESS', lang))
        styleHeaderRow(awarenessSheet.addRow([
            Localize('VSEC_COL_TEAM', lang),
            Localize('VSEC_COL_ASSIGNED_AWARENESS', lang),
            Localize('VSEC_COL_COMPLETED', lang),
            Localize('VSEC_COL_AWARENESS_RATE', lang)
        ]))
        teamRows.forEach((r) => {
            styleBodyRow(awarenessSheet.addRow([
                r.team_name || '',
                toNum(r.awareness_total),
                toNum(r.awareness_completed),
                `${toNum(r.awareness_rate)}%`
            ]))
        })
        awarenessSheet = this.autoWidth(awarenessSheet)

        // ── Sheet 3: Quiz par équipe ─────────────────────────────────────────
        let quizSheet = workbook.addWorksheet(Localize('VSEC_TAB_QUIZ', lang))
        styleHeaderRow(quizSheet.addRow([
            Localize('VSEC_COL_TEAM', lang),
            Localize('VSEC_COL_ASSIGNED_QUIZZES', lang),
            Localize('VSEC_COL_PASSED', lang),
            Localize('VSEC_COL_QUIZ_RATE', lang)
        ]))
        teamRows.forEach((r) => {
            styleBodyRow(quizSheet.addRow([
                r.team_name || '',
                toNum(r.quizzes_total),
                toNum(r.quizzes_passed),
                `${toNum(r.quizzes_rate)}%`
            ]))
        })
        quizSheet = this.autoWidth(quizSheet)

        const fmtDate = (d) => (d ? moment(d).format('DD-MM-YYYY HH:mm') : '')
        const sheetName = (s) => s.slice(0, 31)

        // ── Sheet 4: Détail Sensibilisation (per-collab × campaign) ────────────
        let awarenessDetailSheet = workbook.addWorksheet(sheetName(
            `${Localize('VSEC_TAB_AWARENESS', lang)} - ${Localize('VSEC_TAB_BY_COLLAB', lang)}`
        ))
        styleHeaderRow(awarenessDetailSheet.addRow([
            Localize('VSEC_EXPORT_COL_LASTNAME', lang),
            Localize('VSEC_EXPORT_COL_FIRSTNAME', lang),
            Localize('VSEC_EXPORT_COL_EMAIL', lang),
            Localize('VSEC_EXPORT_COL_TEAM', lang),
            Localize('VSEC_COL_TITLE', lang),
            Localize('VSEC_COL_PUBLISH_DATE', lang),
            Localize('VSEC_EXPORT_COL_STATUS', lang),
            Localize('VSEC_EXPORT_COL_APPROVAL_DATE', lang)
        ]))
        ;(Array.isArray(awarenessDetails) ? awarenessDetails : []).forEach((r) => {
            styleBodyRow(awarenessDetailSheet.addRow([
                r.lastname || '',
                r.firstname || '',
                r.email || '',
                r.team_name || '',
                r.campaign_title || '',
                fmtDate(r.published_at),
                r.is_acknowledged
                    ? Localize('VSEC_EXPORT_STATUS_READ', lang)
                    : Localize('VSEC_EXPORT_STATUS_PENDING', lang),
                fmtDate(r.acknowledged_at)
            ]))
        })
        awarenessDetailSheet = this.autoWidth(awarenessDetailSheet)

        // ── Sheet 5: Détail Quiz (per-collab × quiz) ─────────────────────────
        let quizDetailSheet = workbook.addWorksheet(sheetName(
            `${Localize('VSEC_TAB_QUIZ', lang)} - ${Localize('VSEC_TAB_BY_COLLAB', lang)}`
        ))
        styleHeaderRow(quizDetailSheet.addRow([
            Localize('VSEC_EXPORT_COL_LASTNAME', lang),
            Localize('VSEC_EXPORT_COL_FIRSTNAME', lang),
            Localize('VSEC_EXPORT_COL_EMAIL', lang),
            Localize('VSEC_EXPORT_COL_TEAM', lang),
            Localize('VSEC_COL_TITLE', lang),
            Localize('VSEC_COL_MIN_SCORE', lang),
            Localize('VSEC_COL_NB_ATTEMPTS', lang),
            Localize('VSEC_COL_BEST_SCORE', lang),
            Localize('VSEC_COL_PASSED', lang),
            Localize('VSEC_COL_LAST_ATTEMPT', lang)
        ]))
        ;(Array.isArray(quizDetails) ? quizDetails : []).forEach((r) => {
            styleBodyRow(quizDetailSheet.addRow([
                r.lastname || '',
                r.firstname || '',
                r.email || '',
                r.team_name || '',
                r.quiz_title || '',
                toNum(r.passing_score),
                toNum(r.attempt_count),
                r.best_score == null ? '' : toNum(r.best_score),
                Localize(r.has_passed ? 'YES' : 'NO', lang),
                fmtDate(r.last_attempt_date)
            ]))
        })
        quizDetailSheet = this.autoWidth(quizDetailSheet)

        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const stamp = moment().format('YYYY-MM-DD_HH-mm')
        saveAs(blob, `VSecurite_Dashboard_${stamp}.xlsx`)
    }

    /**
     * Generate and download a V-Sécurité quiz-tracking workbook for a single
     * quiz. Produces two sheets: "Par Collaborateur" (one row per assigned
     * collab) and "Par Équipe" (aggregated stats per team).
     *
     * @param {Array}  details   Per-collab rows: { firstname, lastname, email, team_name,
     *                           attempt_count, best_score, has_passed, in_progress_count, last_attempt_date }
     * @param {Array}  teamStats Per-team rows: { team_name, members, passed, rate }
     * @param {object} quiz      The quiz { id, title }
     * @param {string} lang      Active language code
     */
    async generateAndDownloadVSecuriteQuizTrackingReport(details, teamStats, quiz, lang) {
        const workbook = new ExcelJS.Workbook()
        workbook.creator = 'Groupe Vital Dev'
        workbook.created = new Date()

        const headerFill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF9015' } }
        const headerFont = { bold: true, color: { argb: 'FFFFFF' } }
        const borderStyle = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }

        const styleHeaderRow = (row) => {
            row.eachCell((cell) => {
                cell.border = borderStyle
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
                cell.fill = headerFill
                cell.font = headerFont
            })
        }

        const styleBodyRow = (row) => {
            row.eachCell((cell) => {
                cell.border = borderStyle
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
            })
        }

        const toNum = (val) => {
            const n = Number(val)
            return isNaN(n) ? 0 : n
        }
        const fmtDate = (d) => (d ? moment(d).format('DD-MM-YYYY HH:mm') : '')
        const sheetName = (s) => s.slice(0, 31)

        // Resolve a human-readable status matching the UI status chips.
        const statusLabel = (r) => {
            if (r.has_passed) return Localize('VSEC_STATUS_PASSED_CHIP', lang)
            if (toNum(r.in_progress_count) > 0) return Localize('VSEC_STATUS_IN_PROGRESS_CHIP', lang)
            if (toNum(r.attempt_count) > 0) return Localize('VSEC_STATUS_FAILED_CHIP', lang)
            return Localize('VSEC_STATUS_NOT_STARTED_CHIP', lang)
        }

        // ── Sheet 1: Par Collaborateur ────────────────────────────────────────
        let collabSheet = workbook.addWorksheet(sheetName(Localize('VSEC_TAB_BY_COLLAB', lang)))
        styleHeaderRow(collabSheet.addRow([
            Localize('VSEC_EXPORT_COL_LASTNAME', lang),
            Localize('VSEC_EXPORT_COL_FIRSTNAME', lang),
            Localize('VSEC_EXPORT_COL_EMAIL', lang),
            Localize('VSEC_EXPORT_COL_TEAM', lang),
            Localize('VSEC_COL_NB_ATTEMPTS', lang),
            Localize('VSEC_COL_BEST_SCORE', lang),
            Localize('VSEC_EXPORT_COL_STATUS', lang),
            Localize('VSEC_COL_LAST_ATTEMPT', lang)
        ]))
        ;(Array.isArray(details) ? details : []).forEach((r) => {
            styleBodyRow(collabSheet.addRow([
                r.lastname || '',
                r.firstname || '',
                r.email || '',
                r.team_name || '',
                toNum(r.attempt_count),
                r.best_score == null ? '' : toNum(r.best_score),
                statusLabel(r),
                fmtDate(r.last_attempt_date)
            ]))
        })
        collabSheet = this.autoWidth(collabSheet)

        // ── Sheet 2: Par Équipe ───────────────────────────────────────────────
        let teamSheet = workbook.addWorksheet(sheetName(Localize('VSEC_TAB_BY_TEAM', lang)))
        styleHeaderRow(teamSheet.addRow([
            Localize('VSEC_COL_TEAM', lang),
            Localize('VSEC_COL_MEMBERS', lang),
            Localize('VSEC_COL_PASSED', lang),
            Localize('VSEC_COL_SUCCESS_RATE', lang)
        ]))
        ;(Array.isArray(teamStats) ? teamStats : []).forEach((r) => {
            styleBodyRow(teamSheet.addRow([
                r.team_name || '',
                toNum(r.members),
                toNum(r.passed),
                `${toNum(r.rate)}%`
            ]))
        })
        teamSheet = this.autoWidth(teamSheet)

        const buffer = await workbook.xlsx.writeBuffer()
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const stamp = moment().format('YYYY-MM-DD_HH-mm')
        const safeTitle = (quiz?.title || 'quiz').replace(/[^a-zA-Z0-9_-]+/g, '_').slice(0, 40)
        saveAs(blob, `VSecurite_Quiz_${safeTitle}_${stamp}.xlsx`)
    }

}